export default __webpack_public_path__ + "static/media/cancel_upload.486e7a09.svg";